import { useState } from 'react';
import classes from 'classnames';
import styles from './VersionInfo.module.scss';

const VERSION = '[VI]{version} - {date}[/VI]';

export default function VersionInfo() {
  const [toggle, setToggle] = useState<boolean>(false);

  const handleToggle = () => {
    setToggle(!toggle);
  };

  return (
    <>
      {process.env.REACT_APP_ENV !== 'production' && (
        <div
          className={classes(
            styles.version,
            toggle ? styles.fixed : styles.hover,
          )}
          onClick={handleToggle}
        >
          <div className={styles.inner}>version: {VERSION}</div>
        </div>
      )}
    </>
  );
}
